export default __webpack_public_path__ + "static/media/libreta-boligrafo.e6545d6e.png";